import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getCampaignQueryKey } from "../lib/campaignQuery"

export function useCancelCampaignLaunchMutation(campaignId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (launchId: string) => {
      return axios.post(`/campaigns/${campaignId}/launches/${launchId}/cancel`)
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: getCampaignQueryKey(campaignId) }),
  })
}
